<template>
    <div class="detail-info-header">
        <div class="mg-container">
            <div
                class="image-count"
                v-if="imageCount > 1"
                @click="touched()"
                style="cursor: pointer"
            >
                <span class="iconfont icon-pic"></span
                >{{ $t('md-detail-info.seeAllPhotos', { count: imageCount }) }}
            </div>
            <div class="top-content">
                <Provided
                    v-if="positionProvided && positionProvided === PROVIDED_POSITION_KEY.top"
                    theme="template4"
                />
                <!-- other components between Provided top and Provided above -->
                <Provided
                    v-if="positionProvided && positionProvided === PROVIDED_POSITION_KEY.above"
                    theme="template4"
                />
                <div class="price-caculator">
                    <price class="price" />
                    <caculator v-if="!hideCalculator" class="caculator" />
                </div>
                <tour-button class="button pc"></tour-button>
            </div>
            <!--<div class="prev-next-box" v-if="!isMobileSize && !showFixedBanner">
                <div class="banner-left" v-if="prevAndNext.show">
                    <template v-if="prevAndNext.canPrev">
                        <a
                            class="btn"
                            :href="prevAndNext.prevHref || null"
                            self="true"
                            rel="noopener noreferrer"
                        >
                            <span class="iconfont icon-next-big prev"></span>
                            <span class="text">{{
                                $t('md-detail-info.prev')
                            }}</span>
                        </a>
                        <div class="bg-img-box">
                            <site-img
                                :src="prevAndNext.prevImg"
                                class="bg-img"
                            />
                        </div>
                    </template>
                </div>
                <div class="banner-right" v-if="prevAndNext.show">
                    <template v-if="prevAndNext.canNext">
                        <a
                            class="btn"
                            :href="prevAndNext.nextHref || null"
                            self="true"
                            rel="noopener noreferrer"
                        >
                            <span class="text">{{
                                $t('md-detail-info.next')
                            }}</span>
                            <span class="iconfont icon-next-big next"></span>
                        </a>
                        <div class="bg-img-box">
                            <site-img
                                :src="prevAndNext.nextImg"
                                class="bg-img"
                            />
                        </div>
                    </template>
                </div>
            </div>-->
            <house-tag
                v-bind="infoFlag.tag"
                v-if="infoFlag.tag && isMobileSize"
                theme="v4"
            />
            <div class="count-house-status">
                <count class="count" />
                <template v-if="!isMobileSize">
                    <house-tag
                        v-bind="infoFlag.exclusiveTag"
                        v-if="infoFlag.exclusiveTag"
                        theme="v4" />
                    <house-tag
                        v-bind="infoFlag.tag"
                        v-if="infoFlag.tag"
                        theme="v4"
                    /></template>
            </div>
            <Addr tag="h1" theme="dark" />
            <tour-button class="button mobile"></tour-button>
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import Provided from '../../provided';
import price from './price.vue';
import caculator from './caculator.vue';
import count from './count.vue';
import TourButton from './tour-button.vue';
import Addr from '../../_components/address.vue';

import houseTag from '@/modules/md-house/_component/house-tag';
import { PROVIDED_POSITION_KEY } from '@/common/mls';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['onFavoriteClick', 'getGalleryPopIns'],
    components: {
        Provided,
        price,
        count,
        caculator,
        TourButton,
        Addr,
        houseTag
    },
    props: ['positionProvided', 'showFixedBanner'],
    data: function() {
        return {
            PROVIDED_POSITION_KEY,
            imageCount: 0
        };
    },
    created() {
        if (this.info.listingPictures) {
            this.imageCount = this.info.listingPictures.split('|').length; 
        } else {
            this.imageCount = 0; 
        }
    },
    computed: {
        ...mapState({
            listingDetail: 'listingDetail',
            prevAndNext: 'prevAndNext',
            infoFlag: 'infoFlag'
        }),
        info() {
            return this.listingDetail.info || {};
        },
        hideCalculator() {
            return (
                this.info.purchaseType == 'For Rent' ||
                this.info.statusOrigin == 'Leased'
            );
        },
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    methods: {
        touched(index, $event, item) {
            this.getGalleryPopIns()?._openGalleryPop(index, $event, item);
        }
    }
};
</script>
<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';

.md-detail-info.fashion {
    .detail-info-header {
        position: relative;
        background-color: #242a3d;
        padding-top: 15px;
        padding-bottom: 31px;
        margin-bottom: 50px;
        .address-container {
            margin-top: 20px;
        }
        .image-count {
            position: absolute;
            right: 0px;
            padding: 7px 8px;
            background-color: rgba(74, 74, 96, 0.8);
            font-size: 14px;
            color: white;
            top: -35px;
            transform: translateY(-100%);
            z-index: var(--level-low);
        }
        /*
        .prev-next-box {
            width: 100%;
            height: 0;
            position: relative;
            .banner-left {
                left: 0px;
                transform: translateX(-100%);
                padding-right: 20px;
            }
            .banner-right {
                right: 0px;
                transform: translateX(100%);
                padding-left: 20px;
            }
            .banner-left,
            .banner-right {
                @media screen and (max-width: 1230px) {
                    display: none;
                }
                width: 100px;
                height: 60px;
                top: -20px;
                box-sizing: border-box;
                position: absolute;
                .bg-img-box {
                    opacity: 0;
                    position: relative;
                    &:after {
                        content: '';
                        position: absolute;
                        width: 80px;
                        height: 60px;
                        top: 0;
                        left: 0;
                        background-color: rgba(0, 0, 0, 0.1);
                    }
                    .bg-img {
                        width: 80px;
                        height: 60px;
                        display: inline-block;
                    }
                }
                .btn {
                    color: #adb9d1;
                    position: absolute;
                    height: 25px;
                    width: 80px;
                    border-radius: 2px;
                    border: solid 1px #adb9d1;
                    text-align: center;
                    font-size: 14px;
                    font-family: var(--font-bold);
                    line-height: 23px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    display: block;
                    &:hover {
                        cursor: pointer;
                        border: none;
                        color: #ffffff;
                        line-height: 25px;
                        + .bg-img-box {
                            opacity: 1;
                        }
                    }
                    .iconfont {
                        font-size: 12px;
                        &.prev {
                            transform: rotate(180deg);
                            display: inline-block;
                        }
                    }
                }
            }
        }
        */
        .top-content {
            position: relative;
            margin-bottom: 3px;
            .mls-provided {
                color: #bfc9e4;
            }
            .price-caculator {
                .price {
                    display: inline-block;
                }
                .caculator {
                    display: inline-block;
                    margin-left: 25px;
                }
            }

            .button.pc {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
        .count-house-status {
            margin-top: 14px;
            font-size: 0;
            .count {
                display: inline-block;
            }
            .house-status {
                vertical-align: bottom;
                margin-right: 5px;
            }
        }
        .button.mobile {
            display: none;
        }
    }
    @include media-600 {
        .detail-info-header {
            padding: 0;
            .nodisclosure {
                .dollar {
                    font-size: 16px;
                }
            }
            .mg-container {
                padding: 15px 0;
                .image-count {
                    display: none;
                }
                .mls-provided {
                    text-align: left;
                }
            }
            .top-content {
                .price-caculator {
                    position: relative;
                    .price {
                        .price-container {
                            display: block;
                        }
                        .origin-price {
                            .deprecated {
                                margin-left: 0;
                            }
                        }
                    }
                }
                .button.pc {
                    display: none;
                }
            }
            .count-house-status {
                margin-top: 0;
                .count {
                    margin-top: 11px;
                    display: block;
                }
                .house-status {
                    margin: 0;
                }
            }
            .button.mobile {
                display: flex;
                position: static;
                .btn-item {
                    .iconfont {
                        line-height: 1;
                    }
                }
            }
        }
    }
}
</style>
